import React from "react";
import PropTypes from "prop-types";
//Material imports
import Typography from "@mui/material/Typography";
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import { withi18n } from "../../../../customer/components";
const ReadOnlyField = ({
  t,
  classes,
  label,
  value,
  valueContainerStyles,
  valueColor,
  align,
  disabled,
  children,
  isMandatory,
  background
}) => {
  let containerAlignmentStyles = classes.centerAlign;
  if (align === "left") {
    containerAlignmentStyles = classes.leftAlign;
  }
  let valueStyles = "";
  let labelStyles = classes.label;
  if (disabled) {
    valueStyles = classes.disabled;
    labelStyles = `${labelStyles} ${classes.disabled}`;
  }
  if (background === "white") {
    containerAlignmentStyles = `${containerAlignmentStyles} ${classes.whiteBackground}`;
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    color: "textPrimary",
    id: label,
    className: labelStyles,
    component: "label"
  }, t(label), " ", isMandatory && /*#__PURE__*/React.createElement("div", {
    className: classes.mandatory
  }, "*")), /*#__PURE__*/React.createElement("div", {
    className: `${classes.valueContainer} ${containerAlignmentStyles} ${valueContainerStyles}`
  }, children ? children : /*#__PURE__*/React.createElement(Typography, {
    color: valueColor,
    className: valueStyles
  }, value)));
};
const styles = theme => ({
  label: {
    fontSize: "0.8125rem"
  },
  valueContainer: {
    height: 55,
    minWidth: 95,
    border: theme.palette.border,
    display: "flex",
    flex: 1,
    borderRadius: 4
  },
  leftAlign: {
    paddingLeft: 10,
    justifyContent: "left",
    alignItems: "center"
  },
  centerAlign: {
    justifyContent: "center",
    alignItems: "center"
  },
  disabled: {
    color: theme.palette.action.disabled
  },
  mandatory: {
    display: "inline-flex",
    position: "relative",
    color: theme.palette.error.main,
    bottom: 4,
    marginLeft: 3
  },
  whiteBackground: {
    backgroundColor: "white"
  }
});
export default withStyles(styles)(withi18n(ReadOnlyField));
ReadOnlyField.propTypes = {
  t: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
  label: PropTypes.string,
  value: PropTypes.string,
  valueContainerStyles: PropTypes.string,
  valueColor: PropTypes.string,
  align: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  isMandatory: PropTypes.bool,
  background: PropTypes.string
};
ReadOnlyField.defaultProps = {
  valueContainerStyles: "",
  valueColor: "textPrimary",
  align: "center",
  disabled: false,
  isMandatory: false
};